// extracted by mini-css-extract-plugin
export default {"customPage":"c-b_v"};